import { useEffect } from "react";
import Swal from "sweetalert2";

// Kunci scroll halaman di belakang popup. Pakai hitungan supaya aman kalau
// dua popup terbuka bersamaan (mis. detail student lalu import): halaman baru
// bisa di-scroll lagi setelah popup terakhir ditutup. Lebar scrollbar yang
// hilang diganti padding supaya konten di belakang tidak melompat.
let scrollLocks = 0;
let savedStyles = null;

export const useBodyScrollLock = (active = true) => {
  useEffect(() => {
    if (!active) return undefined;
    const { body, documentElement: html } = document;
    if (scrollLocks === 0) {
      const scrollbarWidth = window.innerWidth - html.clientWidth;
      savedStyles = { bodyOverflow: body.style.overflow, htmlOverflow: html.style.overflow, paddingRight: body.style.paddingRight };
      body.style.overflow = "hidden";
      html.style.overflow = "hidden";
      if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`;
    }
    scrollLocks += 1;
    return () => {
      scrollLocks -= 1;
      if (scrollLocks === 0 && savedStyles) {
        body.style.overflow = savedStyles.bodyOverflow;
        html.style.overflow = savedStyles.htmlOverflow;
        body.style.paddingRight = savedStyles.paddingRight;
        savedStyles = null;
      }
    };
  }, [active]);
};

// Helper kecil yang dipakai semua bagian halaman Student Package.

export const BRAND = "#fb3104";

export const errorMessage = (err, fallback = "Something went wrong. Please try again.") =>
  err?.response?.data?.msg || fallback;

// 401 = session admin habis → kembali ke login (pola halaman admin lain).
export const handleError = (err, navigate, fallback) => {
  if (err?.response?.status === 401) {
    Swal.fire({
      title: "Session Expired",
      text: "Please login to your account!",
      icon: "warning",
      confirmButtonColor: BRAND,
    });
    navigate("/loginAdmin");
    return;
  }
  Swal.fire({ text: errorMessage(err, fallback), icon: "error", confirmButtonColor: BRAND });
};

export const toast = (title, icon = "success") =>
  Swal.fire({ toast: true, position: "top-end", icon, title, showConfirmButton: false, timer: 2200 });

// Escape untuk teks yang disisipkan ke `html` SweetAlert.
export const esc = (value) =>
  String(value ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);

export const formatDateTime = (value) => {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const batchLabel = (b) => `Batch ${b} (${Number(b) + 2021}/${Number(b) + 2022})`;

// Asal aksi admin (metadata.source di riwayat).
export const SOURCE_LABEL = {
  detail_page: "Student Package page",
  qr_scanner: "QR scanner",
  spreadsheet_import: "Spreadsheet import",
  edit_student_orientation: "Edit Student (Orientation)",
};

export const ACTION_LABEL = {
  created: "Package record created",
  added_from_batch: "Added from batch configuration",
  received: "Marked as received",
  reverted: "Reverted to pending",
  notes_updated: "Notes updated",
  qr_revoked: "QR Code revoked",
  item_added: "Added to this student",
  item_removed: "Removed from this student",
  import_created: "Received (spreadsheet import)",
  import_received: "Pending → received (spreadsheet import)",
  import_removed: "Removed by spreadsheet import",
  item_created: "Item created",
  item_updated: "Item edited",
  item_activated: "Item activated",
  item_deactivated: "Item deactivated",
  batch_item_added: "Added to batch",
  batch_item_removed: "Removed from batch",
};
